<script setup>
import Dialog from "primevue/dialog";
import { ref } from "vue";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";

const props = defineProps({
  season_rate_code_id: Number,
  hotel_room_view_id: Number,
  avaliable_days_check_in: String,
  avaliable_days_check_out: String,
});

const visible = ref(false);
const check_in = ref(null);
const check_out = ref(null);
const title = ref("");
const loading = ref(false);

const addRateCode = () => {
  if (!check_in.value || !check_out.value) {
    Swal.fire({
      title: "Error",
      text: "Please select both check-in and check-out dates",
      icon: "error",
    });
    return;
  }

  // توليد قائمة الأيام مع التاريخ + اليوم
  const days = getDaysBetweenInclusive(check_in.value, check_out.value);
  console.log(days);




  console.log(days)
  const data = {
    season_rate_code_id: props.season_rate_code_id,
    hotel_room_view_id: props.hotel_room_view_id,
    title: title.value,
    days,
  };

  loading.value = true;
  axios
    .post("/store_rate_code_group", data)
    .then(({ data }) => {
      Swal.fire({
        title: "",
        text: data.message,
        icon: "success",
      });
      visible.value = false;
      check_in.value = null;
      check_out.value = null;
      title.value = "";
      loading.value = false;
    })
    .catch(({ response }) => {
      loading.value = false;
      Swal.fire({
        title: "",
        text: response.data.message,
        icon: "error",
      });
    });
};

function getDaysBetweenInclusive(checkInRaw, checkOutRaw) {
  const start = moment(checkInRaw);
  const end   = moment(checkOutRaw);

  if (!start.isValid() || !end.isValid()) {
    console.error("Invalid start or end date", checkInRaw, checkOutRaw);
    return [];
  }

  let current = start.clone().startOf("day");
  let last = end.clone().startOf("day");

  // If start is after end, swap so we always iterate forward
  if (current.isAfter(last)) {
    const tmp = current;
    current = last;
    last = tmp;
  }

  const days = [];
  while (current.isSameOrBefore(last)) {
    days.push({ day: current.format("YYYY-MM-DD") });
    current.add(1, "day");
  }

  return days;
}

</script>

<template>
  <div class="flex justify-center">
    <button @click="visible = true" class="btn PrimaryButton">
      {{ $t("add_group") }}
    </button>
    <Dialog
      v-model:visible="visible"
      modal
      dismissableMask
      :header="$t('add_group')"
      :style="{ width: '50rem', height: '30rem' }"
    >
      <form class="row" @submit.prevent="addRateCode">
        <div class="d-flex flex-column col-6">
          <label for="check_in" class="fw-bold text-dark">
            {{ $t("check_in") }}
          </label>
          <Calendar
            :minDate="new Date(avaliable_days_check_in)"
            :maxDate="new Date(avaliable_days_check_out)"
            v-model="check_in"
            id="check_in"
          />
        </div>
        <div class="d-flex flex-column col-6">
          <label for="check_out" class="fw-bold text-dark">
            {{ $t("check_out") }}
          </label>
          <Calendar
            :maxDate="new Date(avaliable_days_check_out)"
            :minDate="new Date(avaliable_days_check_in)"
            v-model="check_out"
            id="check_out"
          />
        </div>

        <div class="d-flex flex-column col-6 mt-3">
          <label for="title" class="fw-bold text-dark">
            {{ $t("title") }}
          </label>
          <InputText type="text" v-model="title" />
        </div>

        <div class="col-12 mt-3">
          <button type="submit" class="btn PrimaryButton">
            {{ loading ? $t("loading...") : $t("save") }}
          </button>
        </div>
      </form>
    </Dialog>
  </div>
</template>
